import * as axios from "../network/Network";

const config = require("../network/api.json");

class HomeService {
  /**
   * room list
   * @returns
   */
  static roomlist() {
    return axios.appRequest({
      method: axios.GET,
      url: config.user.roomlist,
    });
  }
  static getRoomList(
    arrival_date,
    departure_date,
    no_of_occupancy,
    no_of_room,
    no_of_infants
  ) {
    // let infantss = no_of_infants ? no_of_infants : JSON.stringify([]);
    // const infantsParam = Array.isArray(no_of_infants)
    //   ? no_of_infants.join(",") // Convert array to a comma-separated string
    //   : no_of_infants; // If not an array, send as is

    return axios.appRequest({
      method: axios.GET,
      url:
        config.user.getRoomList +
        `?arrival_date=${arrival_date}&departure_date=${departure_date}&no_of_occupancy=${no_of_occupancy}&no_of_room=${no_of_room}&no_of_infants=${no_of_infants}`,
    });
  }

  static checkRoom(roomLength, adultCount, infantCount, proceed, infantAge) {
    return axios.appRequest({
      method: axios.GET,
      url:
        config.user.checkRooms +
        `?roomLength=${roomLength}&adultCount=${adultCount}&infantCount=${infantCount}&proceed=${proceed}&infantAge=${infantAge}`,
    });
  }
}
export { HomeService };
